import 'css-chunk:src/app/containers/Home/ClientsView/ClientDetailView/ClientIntegrations.scss';export default {
  "ClientIntegrations": "_ClientIntegrations_1c3no_1",
  "applicationsLink": "_applicationsLink_1c3no_1"
};